import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BASE_URL from "api/Api";
import { FaKey, FaPlus, FaEdit, FaTrash, FaCheck, FaTimes, FaShieldAlt, FaCode } from "react-icons/fa";
import "assets/theme/admin_list.css";

function PermissionsList() {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");

  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    try {
      const res = await fetch(`${BASE_URL}super_admin/list_permissions`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      setPermissions(data.permissions || []);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  /*  EDIT  */

  const startEdit = (perm) => {
    setEditingId(perm.permission_id);
    setEditValue(perm.permission_code);
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditValue("");
  };

  const saveEdit = async (id) => {
    try {
      const res = await fetch(
        `${BASE_URL}super_admin/edit_permissions/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ permission_code: editValue }),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      setPermissions((prev) =>
        prev.map((p) =>
          p.permission_id === id
            ? { ...p, permission_code: editValue }
            : p
        )
      );

      cancelEdit();
    } catch (err) {
      alert(err.message);
    }
  };

  /*  DELETE  */

  const deletePermission = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this permission?"
    );

    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${BASE_URL}super_admin/delete_permissions/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      setPermissions((prev) =>
        prev.filter((p) => p.permission_id !== id)
      );
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaKey />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  Permissions List / परवानगी यादी
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  Manage system role-based access control permission codes
                </p>
              </div>
            </div>

            <Link to="/permissions" className="btn btn-admin-add">
              <FaPlus /> <span>Add Permission / परवानगी जोडा</span>
            </Link>
          </div>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="text-muted mt-2 fw-semibold mb-0">माहिती लोड होत आहे...</p>
              </div>
            ) : permissions.length === 0 ? (
              <div className="text-center py-5">
                <FaShieldAlt className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">No permissions found</h6>
                <p className="text-muted small mb-0">No security permission codes have been registered yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-admin-custom align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Sr. No.</th>
                      <th>Permission Code / कोड</th>
                      <th className="text-center" style={{ width: "160px" }}>Actions / क्रिया</th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissions.map((perm, index) => (
                      <tr key={perm.permission_id}>
                        <td>
                          <span className="fw-semibold text-muted">{(index + 1).toString().padStart(2, "0")}</span>
                        </td>
                        <td>
                          {editingId === perm.permission_id ? (
                            <input
                              type="text"
                              className="form-control form-control-sm border-warning font-monospace fw-semibold shadow-sm"
                              value={editValue}
                              onChange={(e) => setEditValue(e.target.value)}
                              autoFocus
                            />
                          ) : (
                            <span className="badge bg-dark bg-opacity-75 text-warning font-monospace px-3 py-2 fs-6">
                              <FaCode className="me-2 text-warning" style={{ fontSize: "0.85rem" }} />
                              {perm.permission_code}
                            </span>
                          )}
                        </td>
                        <td>
                          <div className="d-flex justify-content-center gap-2">
                            {editingId === perm.permission_id ? (
                              <>
                                <button
                                  className="btn btn-sm btn-success px-3 fw-semibold text-white d-flex align-items-center gap-1"
                                  onClick={() => saveEdit(perm.permission_id)}
                                >
                                  <FaCheck /> <span>Save</span>
                                </button>
                                <button
                                  className="btn btn-sm btn-secondary px-2 d-flex align-items-center gap-1"
                                  onClick={cancelEdit}
                                >
                                  <FaTimes />
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn-action-icon edit"
                                  title="Edit Permission"
                                  onClick={() => startEdit(perm)}
                                >
                                  <FaEdit />
                                </button>
                                <button
                                  className="btn-action-icon delete"
                                  title="Delete Permission"
                                  onClick={() => deletePermission(perm.permission_id)}
                                >
                                  <FaTrash />
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default PermissionsList;
